import * as React from 'react';
import { Fragment, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Button as RButton,
  useUpdateMany,
  useRefresh,
  useNotify,
  useUnselectAll,
  Confirm,
} from 'react-admin';
import { Save as SaveIcon } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const generateBulkData = (type, source, value, booleanValue) => {
  let data = {};
  if (type === 'select') {
    return {
      [source]: value,
    }
  } else if (type === 'boolean') {
    return {
      [source]: booleanValue,
    }
  }
  return data;
}

const BulkActionButton = ({
  selectedIds,
  type,
  source,
  sourceName,
  resource,
  resourceLabel,
  icon,
  booleanValue,
  options = [],
}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const { handleSubmit, errors, control } = useForm();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();

  const bulkData = generateBulkData(type, source, value, booleanValue);

  const [updateMany, { loading }] = useUpdateMany(
    resource,
    selectedIds,
    bulkData,
    {
      onSuccess: () => {
        refresh();
        notify(`${resourceLabel} updated`);
        unselectAll(resource);
      },
      onFailure: (error) => notify(`Error: ${resourceLabel} not updated`, 'warning'),
    }
  );

  useEffect(() => {
    if (value) {
      updateMany();
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    setValue(data.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    updateMany();
    setOpen(false);
  };

  const renderField = () => {
    if (type === 'select') {
      return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
          <DialogTitle id="form-dialog-title">Set {sourceName}</DialogTitle>
          <DialogContent>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth error={!!errors.value}>
                    <InputLabel id="value">{sourceName}</InputLabel>
                    <Controller
                      as={
                        <Select>
                          <MenuItem value=""></MenuItem>
                          {options.map((value) => (
                            <MenuItem key={value.id} value={value.id}>
                              {value.name}
                            </MenuItem>
                          ))}
                        </Select>
                      }
                      name="value"
                      rules={{ required: 'required' }}
                      control={control}
                      defaultValue=""
                    />
                    <FormHelperText>{errors.value && errors.value.message}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            {!loading && (
              <Button
                onClick={handleSubmit(onSubmit)}
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
              >
                Save
              </Button>
            )}
            {loading && (
              <Button variant="contained" color="primary" startIcon={<SaveIcon />} disabled>
                Save
              </Button>
            )}
          </DialogActions>
        </Dialog>
      );
    } else if (type === 'boolean'){
      return (
        <Confirm
          isOpen={open}
          loading={loading}
          title={`Update ${sourceName}`}
          content={`Are you sure you want to "${sourceName}" for these items?`}
          onConfirm={handleConfirm}
          onClose={handleClose}
        />
      );
    }
    return null;
  };

  return (
    <Fragment>
      <RButton label={sourceName} onClick={handleClickOpen}>
        {icon}
      </RButton>
      {renderField()}
    </Fragment>
  );
};

export default BulkActionButton;
